import { render } from "./EmptyDataTableComponent.vue?vue&type=template&id=2d275dbd&scoped=true"
import script from "./EmptyDataTableComponent.vue?vue&type=script&lang=js"
export * from "./EmptyDataTableComponent.vue?vue&type=script&lang=js"

import "./EmptyDataTableComponent.vue?vue&type=style&index=0&id=2d275dbd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d275dbd"]])

export default __exports__